module.exports = __webpack_public_path__ + "img/loader.942ff475.gif";